import { __assign } from "tslib";
import React from 'react';
var IS_SAFARI = navigator.userAgent.indexOf('Safari') !== -1 &&
    navigator.userAgent.indexOf('Chrome') === -1;
export function ScrollSnapMarkers(_a) {
    var imageHeight = _a.imageHeight, imageWidth = _a.imageWidth, containerHeight = _a.containerHeight, containerWidth = _a.containerWidth;
    var style = {
        scrollSnapAlign: 'start',
        position: 'absolute',
    };
    var numberOfElementsX = Math.ceil(imageWidth / containerWidth);
    var numberOfElementsY = Math.ceil(imageHeight / containerHeight);
    var markers = [];
    for (var x = 0; x < numberOfElementsX; x += 1) {
        for (var y = 0; y < numberOfElementsY; y += 1) {
            var left = x * containerWidth;
            var width = Math.min(containerWidth, imageWidth - left);
            var top = y * containerHeight;
            var height = Math.min(containerHeight, imageHeight - top);
            markers.push(React.createElement("div", { key: "x-".concat(x, "-y-").concat(y), style: __assign(__assign({}, style), { top: y * containerHeight, left: x * containerWidth, width: width, height: height }) }));
        }
    }
    return React.createElement(React.Fragment, null, markers);
}
var directionToAxisMap = {
    horizontal: 'x',
    vertical: 'y',
    both: 'both',
};
export function getScrollSnapType(behaviour, direction, isDragging) {
    if (isDragging && !IS_SAFARI) {
        // in Chrome(etc?) we need to turn off scroll snapping while programmatically
        // scrolling (via drag scroll or scrollbars) otherwise the content doesn't
        // scroll until a snap point is hit (so looks like scrolling isn't working
        // to begin with).
        //
        // Turns out we don't need to do this in Safari. Also Safari has a bug where
        // it snaps to the wrong position when you dynamically update the scroll
        // snap -- it always completely unscrolls the content
        return {
            scrollSnapType: 'none',
        };
    }
    if (behaviour === 'normal') {
        return;
    }
    return {
        scrollSnapType: "".concat(directionToAxisMap[direction], " mandatory"),
    };
}
